// extracted by mini-css-extract-plugin
export default {"App":"App_App__HxVoM","App-logo":"App_App-logo__e9Qmd","App-header":"App_App-header__4i38v","App-link":"App_App-link__0gygu"};